import { render } from "./ChatMessagesBlock.vue?vue&type=template&id=2c2ca9e0"
import script from "./ChatMessagesBlock.vue?vue&type=script&lang=js"
export * from "./ChatMessagesBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__